export const lightTheme = {
  button: {
    defaultProps: { className: 'normal-case rounded-lg px-3 py-[10px] font-semibold text-sm' },
    styles: {
      variants: {
        filled: {
          gray: {
            backgroud: 'bg-primary text-on-primary',
          },
          teal: {
            backgroud: 'bg-primary text-on-primary',
          },
        },
        text: {
          gray: {
            backgroud: 'text-on-surface-variant',
          },
          teal: {
            backgroud: 'text-primary',
          },
          red: {
            backgroud: 'text-error',
          },
        },
        outlined: {
          red: {
            backgroud: 'text-error',
            border: 'border border-error',
          },
          gray: {
            backgroud: 'text-on-surface-variant',
            border: 'border border-outline-variant',
          },
          teal: {
            backgroud: 'text-primary',
            border: 'border border-primary',
          },
        },
      },
    },
  },
  navbar: {
    defaultProps: { className: 'bg-system' },
  },
  typography: {
    defaultProps: {
      color: 'gray',
      variant: 'paragraph',
    },
    valid: {
      colors: ['black', 'teal', 'blue', 'gray', 'blue-gray', 'indigo', 'amber', 'red', 'lime', 'light-green'],
      variants: ['h3', 'h4', 'h5', 'h6', 'paragraph', 'small'],
    },
    styles: {
      colors: {
        black: {
          color: 'text-black',
        },
        teal: {
          color: 'text-primary',
        },
        blue: {
          color: 'text-information',
        },
        gray: {
          color: 'text-on-surface-variant',
        },
        'blue-gray': {
          color: 'text-outline-variant',
        },
        indigo: {
          color: 'text-neutral-40',
        },
        amber: {
          color: 'text-on-surface',
        },
        red: {
          color: 'text-error',
        },
        lime: {
          color: 'text-outline',
        },
        'light-green': {
          color: 'text-grey-tone',
        },
      },
      variants: {
        h2: {
          fontSize: 'text-3xl',
          lineHeight: '40px',
          letterSpacing: '0px',
          fontWeight: '700',
        },
        h3: {
          fontSize: 'text-2xl',
          lineHeight: '32px',
          letterSpacing: '0px',
          fontWeight: '700',
        },
        h4: {
          fontSize: 'text-xl',
          lineHeight: '28px',
          letterSpacing: '0px',
          fontWeight: '700',
        },
        h5: {
          fontSize: 'text-base',
          lineHeight: '24px',
          letterSpacing: '0.15px',
          fontWeight: '700',
        },
        h6: {
          fontSize: 'text-base',
          lineHeight: '24px',
          letterSpacing: '0.5px',
          fontWeight: '700',
        },
        paragraph: {
          fontSize: 'text-base',
          lineHeight: '20px',
          letterSpacing: '0.25px',
          fontWeight: '400',
        },
        small: {
          fontSize: 'text-sm',
          lineHeight: '16px',
          letterSpacing: '0.4px',
          fontWeight: '400',
        },
      },
    },
  },
  list: {
    defaultProps: { className: 'text-sm' },
    styles: {
      base: {
        item: {
          initial: {
            display: 'flex',
            alignItems: 'items-center',
            width: 'w-full',
            padding: 'p-3',
            borderRadius: 'rounded-xl',
            textAlign: 'text-start',
            lightHeight: 'leading-tight',
            transition: 'transition-all',
            bg: 'hover:bg-grey-dark focus:bg-primary-opacity-10',
            color: 'hover:text-on-surface-variant focus:text-primary active:text-primary',
            outline: 'outline-none',
            font: 'font-medium hover:font-bold',
          },
          selected: {
            bg: 'bg-primary-opacity-10',
            color: 'text-primary',
            font: 'font-bold',
          },
        },
      },
    },
  },
  iconButton: {
    defaultProps: { className: 'rounded-lg' },
    styles: {
      variants: {
        filled: {
          gray: {
            backgroud: 'bg-primary',
            color: 'text-on-primary',
          },
        },
        outlined: {
          gray: {
            border: 'border border-outline-variant',
            color: 'text-on-surface-variant',
          },
        },
        text: {
          gray: {
            color: 'text-on-surface-variant',
          },
        },
      },
    },
  },
  input: {
    defaultProps: { color: 'teal' },
    styles: {
      base: {
        input: {
          color: 'text-on-surface-variant',
          disabled: 'disabled:bg-card disabled:border-0',
        },
        label: {
          color: 'peer-placeholder-shown:text-on-surface-variant',
          disabled: 'peer-disabled:text-transparent peer-disabled:peer-placeholder-shown:text-on-surface-variant',
        },
        icon: {
          color: 'text-on-surface-variant',
        },
      },
      variants: {
        outlined: {
          base: {
            input: {
              borderColor: 'placeholder-shown:border-outline-variant placeholder-shown:border-t-outline-variant',
            },
          },
          colors: {
            input: {
              teal: {
                borderColor: 'border-on-surface',
                borderColorFocused: 'focus:border-primary',
              },
            },
            label: {
              teal: {
                color: 'text-on-surface peer-focus:text-primary',
                before: 'before:border-on-surface peer-focus:before:!border-primary',
                after: 'after:border-on-surface peer-focus:after:!border-primary',
              },
            },
          },
          error: {
            input: {
              borderColor: 'border-error placeholder-shown:border-t-error placeholder-shown:border-error',
              borderColorFocused: 'focus:border-error',
            },
            label: {
              color: 'text-error peer-focus:text-error peer-placeholder-shown:text-on-surface-variant',
              before: 'before:border-error peer-focus:before:border-error',
              after: 'after:border-error peer-focus:after:border-error',
            },
          },
        },
      },
    },
  },
  link: {
    defaultProps: { className: 'text-information hover:text-primary' },
  },
  accordion: {
    defaultProps: {},
    styles: {
      base: {
        header: {
          initial: {
            py: 'p-3',
            borderWidth: 'border-b border-b-primary',
            color: 'text-on-surface-variant',
            fontFamily: 'font-sans',
            fontSize: 'text-sm',
            fontWeight: 'font-body',
            lineHeight: 'leading-tight',
            hover: 'hover:text-primary',
            transition: 'transition-colors',
          },
          active: { color: 'text-primary' },
        },
      },
    },
  },
  chip: {
    defaultProps: {
      className: 'normal-case text-sm',
    },
    valid: {
      variants: ['filled'],
      colors: ['teal', 'red'],
    },
    styles: {
      variants: {
        filled: {
          teal: {
            backgroud: 'bg-primary-opacity-20',
            color: 'text-primary',
          },
          red: {
            backgroud: 'bg-error-opacity-20',
            color: 'text-error',
          },
          yellow: {
            backgroud: 'bg-yellow-2',
            color: 'text-brown',
          },
        },
        outlined: {
          'blue-gray': {
            background: 'text-on-surface-variant bg-transparent',
            border: 'border border-outline-variant',
          },
          gray: {
            background: 'text-lost bg-lost-10',
            border: 'border border-lost',
          },
          teal: {
            background: 'text-returned bg-returned-10',
            border: 'border border-returned',
          },
          red: {
            background: 'text-error bg-error-10',
            border: 'border border-error',
          },
          yellow: {
            backgroud: 'bg-overdue-10 text-overdue ',
            border: 'border border-overdue',
          },
          blue: {
            backgroud: 'bg-information-10 text-information',
            border: 'border border-information',
          },
          'light-blue': {
            backgroud: 'bg-on-hold-10 text-on-hold',
            border: 'border border-on-hold',
          },
        },
        ghost: {
          gray: {
            backgroud: 'bg-secondary-08',
            color: 'text-secondary',
          },
          green: {
            backgroud: 'bg-returned-10',
            color: 'text-returned',
          },
        },
      },
    },
  },
  switch: {
    valid: {
      colors: ['teal'],
    },
    styles: {
      base: {
        root: {
          display: 'inline-flex',
          alignItems: 'items-center',
          flexDirection: 'flex-row-reverse',
        },
        label: {
          fontSize: 'text-sm',
          lineHeight: '20px',
          letterSpacing: '0.25px',
          fontWeight: '400',
          color: 'text-on-surface',
          ml: 'ml-0',
          mr: 'mr-3',
        },
      },
      colors: {
        teal: {
          input: 'checked:bg-primary',
          circle: 'peer-checked:border-primary',
          before: 'peer-checked:before:bg-primary',
        },
      },
    },
  },
  dialog: {
    defaultProps: {
      className: 'bg-others-white',
    },
  },
  card: {
    defaultProps: { className: 'bg-card' },
  },
  checkbox: {
    valid: {
      colors: ['teal', 'gray'],
    },
    styles: {
      colors: {
        teal: {
          background: 'checked:bg-primary',
          border: 'checked:border-primary',
          before: 'checked:before:bg-primary',
        },
        gray: {
          background: 'checked:bg-on-surface-variant',
          border: 'border-2 boder-secondary checked:border-on-surface-variant',
          before: 'checked:before:bg-on-surface-variant',
        },
      },
    },
  },
  select: {
    styles: {
      base: {
        select: {
          color: 'text-on-surface',
        },
        arrow: {
          initial: {
            color: 'text-on-surface-variant',
          },
        },
        menu: {
          bg: 'bg-others-white',
          color: 'text-on-surface',
        },
      },
      variants: {
        outlined: {
          colors: {
            select: {
              gray: {
                close: {
                  borderColor: 'border-outline-variant',
                },
                open: {
                  borderColor: 'border-primary',
                },
                withValue: {
                  borderColor: 'border-on-surface',
                },
              },
            },
            label: {
              gray: {
                close: {
                  color: 'text-on-surface',
                  before: 'before:border-outline-variant',
                  after: 'after:border-outline-variant',
                },
                open: {
                  color: 'text-primary',
                  before: 'before:border-primary',
                  after: 'after:border-primary',
                },
                withValue: {
                  color: 'text-on-surface',
                  before: 'before:border-on-surface',
                  after: 'after:border-on-surface',
                },
              },
            },
          },
        },
      },
    },
  },
  menu: {
    styles: {
      base: {
        menu: {
          bg: 'bg-highground',
          border: 'border border-outline-variant',
          color: 'text-secondary',
          zIndex: 'z-[999]',
        },
        item: {
          initial: {
            bg: 'hover:bg-outline-soft-16 focus:bg-outline-soft-16 active:bg-outline-soft-16',
            color: 'hover:text-on-surface-variant focus:text-on-surface-variant active:text-on-surface-variant',
            outline: 'outline-none',
          },
        },
      },
    },
  },
  tooltip: {
    defaultProps: {
      className: 'border border-grey-scale shadow-xl',
    },
    styles: {
      base: {
        bg: 'bg-grey-tone-card',
        py: 'py-3',
        px: 'px-3',
        borderRadius: 'rounded-lg',
        color: 'text-on-surface-variant',
      },
    },
  },
  tab: {
    styles: {
      base: {
        indicator: {
          bg: 'bg-others-white',
        },
      },
    },
  },
  progress: {
    valid: {
      variants: ['filled'],
      colors: ['blue'],
    },
    styles: {
      base: {
        container: {
          initial: {
            bg: 'bg-grey-dark',
          },
        },
      },
      variants: {
        filled: {
          blue: {
            backgroud: 'bg-information',
            color: 'text-information',
          },
        },
      },
    },
  },
  drawer: {
    defaultProps: {
      size: 719,
    },
  },
}

export const darkTheme = {
  button: {
    defaultProps: { className: 'normal-case rounded-lg px-3 py-[10px] font-semibold text-sm' },
    styles: {
      variants: {
        filled: {
          gray: {
            backgroud: 'bg-primary text-on-primary',
          },
          teal: {
            backgroud: 'bg-primary text-on-primary',
          },
        },
        text: {
          gray: {
            backgroud: 'text-on-surface-variant',
          },
          teal: {
            backgroud: 'text-primary',
          },
          red: {
            backgroud: 'text-error',
          },
        },
        outlined: {
          gray: {
            backgroud: 'text-on-surface-variant',
            border: 'border border-outline-variant',
          },
          red: {
            backgroud: 'text-error',
            border: 'border border-error',
          },
        },
        teal: {
          backgroud: 'text-primary',
          border: 'border border-primary',
        },
      },
    },
  },
  navbar: {
    defaultProps: { className: 'bg-dark-6' },
  },
  typography: {
    defaultProps: {
      color: 'gray',
      className: '',
    },
    valid: {
      colors: ['black', 'teal', 'blue', 'gray', 'blue-gray', 'indigo', 'amber', 'red', 'lime', 'light-green'],
      variants: ['h3', 'h4', 'h5', 'h6', 'paragraph', 'small'],
    },
    styles: {
      colors: {
        black: {
          color: 'text-white',
        },
        teal: {
          color: 'text-primary',
        },
        blue: {
          color: 'text-information',
        },
        gray: {
          color: 'text-on-surface-variant',
        },
        'blue-gray': {
          color: 'text-outline-variant',
        },
        indigo: {
          color: 'text-dark-10',
        },
        amber: {
          color: 'text-on-surface',
        },
        red: {
          color: 'text-error',
        },
        lime: {
          color: 'text-outline',
        },
        'light-green': {
          color: 'text-grey-tone',
        },
      },
      variants: {
        h2: {
          fontSize: 'text-3xl',
          lineHeight: '40px',
          letterSpacing: '0px',
          fontWeight: '700',
        },
        h3: {
          fontSize: 'text-2xl',
          lineHeight: '32px',
          letterSpacing: '0px',
          fontWeight: '700',
        },
        h4: {
          fontSize: 'text-xl',
          lineHeight: '28px',
          letterSpacing: '0px',
          fontWeight: '700',
        },
        h5: {
          fontSize: 'text-base',
          lineHeight: '24px',
          letterSpacing: '0.15px',
          fontWeight: '700',
        },
        h6: {
          fontSize: 'text-base',
          lineHeight: '24px',
          letterSpacing: '0.5px',
          fontWeight: '700',
        },
        paragraph: {
          fontSize: 'text-base',
          lineHeight: '20px',
          letterSpacing: '0.25px',
          fontWeight: '400',
        },
        small: {
          fontSize: 'text-sm',
          lineHeight: '16px',
          letterSpacing: '0.4px',
          fontWeight: '400',
        },
      },
    },
  },
  iconButton: {
    defaultProps: { className: 'rounded-lg' },
    styles: {
      variants: {
        filled: {
          gray: {
            backgroud: 'bg-primary',
            color: 'text-on-primary',
          },
        },
        outlined: {
          gray: {
            border: 'border border-outline-variant',
            color: 'text-on-surface-variant',
          },
        },
        text: {
          gray: {
            color: 'text-on-surface-variant',
          },
        },
      },
    },
  },
  list: {
    defaultProps: { className: 'text-on-surface-variant text-sm' },
    styles: {
      base: {
        item: {
          initial: {
            display: 'flex',
            alignItems: 'items-center',
            width: 'w-full',
            padding: 'p-3',
            borderRadius: 'rounded-xl',
            textAlign: 'text-start',
            lightHeight: 'leading-tight',
            transition: 'transition-all',
            bg: 'hover:bg-primary-opacity-20 focus:bg-primary-opacity-20',
            color: 'hover:text-primary focus:text-primary active:text-primary',
            outline: 'outline-none',
            font: 'font-medium hover:font-bold',
          },
          selected: {
            bg: 'bg-primary-opacity-20',
            color: 'text-primary',
            font: 'font-bold',
          },
        },
      },
    },
  },
  input: {
    defaultProps: { color: 'teal' },
    styles: {
      base: {
        input: {
          color: 'text-on-surface-variant',
          disabled: 'disabled:bg-card disabled:border-0',
        },
        label: {
          color: 'peer-placeholder-shown:text-on-surface-variant',
          disabled: 'peer-disabled:text-transparent peer-disabled:peer-placeholder-shown:text-on-surface-variant',
        },
        icon: {
          color: 'text-on-surface-variant',
        },
      },
      variants: {
        outlined: {
          base: {
            input: {
              borderColor: 'placeholder-shown:border-outline-variant placeholder-shown:border-t-outline-variant',
            },
          },
          colors: {
            input: {
              teal: {
                borderColor: 'border-on-surface',
                borderColorFocused: 'focus:border-primary',
              },
            },
            label: {
              teal: {
                color: 'text-on-surface peer-focus:text-primary',
                before: 'before:border-on-surface peer-focus:before:!border-primary',
                after: 'after:border-on-surface peer-focus:after:!border-primary',
              },
            },
          },
          error: {
            input: {
              borderColor: 'border-error placeholder-shown:border-t-error placeholder-shown:border-error',
              borderColorFocused: 'focus:border-error',
            },
            label: {
              color: 'text-error peer-focus:text-error peer-placeholder-shown:text-on-surface-variant',
              before: 'before:border-error peer-focus:before:border-error',
              after: 'after:border-error peer-focus:after:border-error',
            },
          },
        },
      },
    },
  },
  card: {
    defaultProps: { className: 'bg-card' },
  },
  accordion: {
    defaultProps: {},
    styles: {
      base: {
        header: {
          initial: {
            py: 'p-3',
            borderWidth: 'border-b border-b-primary',
            color: 'text-white',
            fontFamily: 'font-sans',
            fontSize: 'text-sm',
            fontWeight: 'font-body',
            lineHeight: 'leading-tight',
            hover: 'hover:text-primary',
            transition: 'transition-colors',
          },
          active: { color: 'text-primary' },
        },
      },
    },
  },
  chip: {
    defaultProps: {
      className: 'normal-case text-sm',
    },
    valid: {
      variants: ['filled'],
      colors: ['teal', 'red', 'yellow'],
    },
    styles: {
      variants: {
        filled: {
          teal: {
            backgroud: 'bg-primary bg-opacity-20',
            color: 'text-primary',
          },
          yellow: {
            backgroud: 'bg-yellow-2',
            color: 'text-brown',
          },
        },
        outlined: {
          'blue-gray': {
            background: 'text-on-surface-variant bg-transparent',
            border: 'border border-outline-variant',
          },
          gray: {
            background: 'text-lost bg-lost-10',
            border: 'border border-lost',
          },
          teal: {
            background: 'text-returned bg-returned-10',
            border: 'border border-returned',
          },
          red: {
            background: 'text-error bg-error-10',
            border: 'border border-error',
          },
          yellow: {
            backgroud: 'bg-overdue-10 text-overdue',
            border: 'border border-overdue',
          },
          blue: {
            backgroud: 'bg-information-10 text-information',
            border: 'border border-information',
          },
          'light-blue': {
            backgroud: 'bg-on-hold-10 text-on-hold',
            border: 'border border-on-hold',
          },
        },
        ghost: {
          teal: {
            background: 'bg-teal-300',
            color: 'text-teal-900',
          },
          red: {
            backgroud: 'bg-red-100',
            color: 'text-red-900',
          },
          yellow: {
            backgroud: 'bg-amber-200',
            color: 'text-amber-900',
          },
          blue: {
            backgroud: 'bg-blue-300',
            color: 'text-blue-900',
          },
          green: {
            background: 'bg-teal-200',
            color: 'text-primary-98',
          },
          purple: {
            background: 'bg-purple-100',
            color: 'text-purple-600',
          },
          gray: {
            backgroud: 'bg-secondary-08',
            color: 'text-secondary',
          },
        },
      },
    },
  },
  switch: {
    valid: {
      colors: ['teal'],
    },
    styles: {
      base: {
        root: {
          display: 'inline-flex',
          alignItems: 'items-center',
          flexDirection: 'flex-row-reverse',
        },
        label: {
          fontSize: 'text-sm',
          lineHeight: '20px',
          letterSpacing: '0.25px',
          fontWeight: '400',
          color: 'text-on-surface',
          ml: 'ml-0',
          mr: 'mr-3',
        },
      },
      colors: {
        teal: {
          input: 'checked:bg-primary',
          circle: 'peer-checked:border-primary',
          before: 'peer-checked:before:bg-primary',
        },
      },
    },
  },
  dialog: {
    defaultProps: {
      className: 'bg-others-white',
    },
  },
  menu: {
    styles: {
      base: {
        menu: {
          bg: 'bg-highground',
          border: 'border border-outline-variant',
          color: 'text-secondary',
          zIndex: 'z-[999]',
        },
        item: {
          initial: {
            bg: 'hover:bg-outline-soft-16 focus:bg-outline-soft-16 active:bg-outline-soft-16 ',
            color: 'hover:text-on-surface-variant focus:text-on-surface-variant active:text-on-surface-variant',
            outline: 'outline-none',
          },
        },
      },
    },
  },
  select: {
    styles: {
      base: {
        select: {
          color: 'text-on-surface',
        },
        arrow: {
          initial: {
            color: 'text-on-surface',
          },
        },
        menu: {
          bg: 'bg-others-white',
          color: 'text-on-surface',
        },
      },
      variants: {
        outlined: {
          colors: {
            select: {
              gray: {
                close: {
                  borderColor: 'border-outline-variant',
                },
                open: {
                  borderColor: 'border-primary',
                },
                withValue: {
                  borderColor: 'border-on-surface',
                },
              },
            },
            label: {
              gray: {
                close: {
                  color: 'text-on-surface',
                  before: 'before:border-outline-variant',
                  after: 'after:border-outline-variant',
                },
                open: {
                  color: 'text-primary',
                  before: 'before:border-primary',
                  after: 'after:border-primary',
                },
                withValue: {
                  color: 'text-on-surface',
                  before: 'before:border-on-surface',
                  after: 'after:border-on-surface',
                },
              },
            },
          },
        },
      },
    },
  },
  checkbox: {
    valid: {
      colors: ['teal', 'gray'],
    },
    styles: {
      base: {
        icon: {
          color: 'text-system',
        },
      },
      colors: {
        teal: {
          background: 'checked:bg-primary',
          border: 'checked:border-primary',
          before: 'checked:before:bg-primary',
        },
        gray: {
          background: 'checked:bg-on-surface-variant',
          border: 'border-2 boder-secondary checked:border-on-surface-variant',
          before: 'checked:before:bg-on-surface-variant',
        },
      },
    },
  },
  radio: {
    defaultProps: {
      color: 'gray',
    },
    valid: {
      colors: ['gray'],
    },
    styles: {
      colors: {
        gray: {
          color: 'text-gray-500',
          border: 'checked:border-gray-500',
          before: 'checked:before:bg-gray-500',
        },
      },
    },
  },
  tooltip: {
    defaultProps: {
      className: 'border border-grey-scale shadow-xl',
    },
    styles: {
      base: {
        bg: 'bg-grey-tone-card',
        py: 'py-3',
        px: 'px-3',
        borderRadius: 'rounded-lg ',
        color: 'text-on-surface-variant',
      },
    },
  },
  tab: {
    styles: {
      base: {
        indicator: {
          bg: 'bg-others-white',
        },
      },
    },
  },
  progress: {
    valid: {
      variants: ['filled'],
      colors: ['blue'],
    },
    styles: {
      base: {
        container: {
          initial: {
            bg: 'bg-grey-dark',
          },
        },
      },
      variants: {
        filled: {
          blue: {
            backgroud: 'bg-information',
            color: 'text-information',
          },
        },
      },
    },
  },
  drawer: {
    defaultProps: {
      size: 719,
    },
  },
}

export const mappingTheme = {
  light: lightTheme,
  dark: darkTheme,
}
